import LegalShell, { Section } from "@/components/LegalShell";

export default function RefundPage() {
  return (
    <LegalShell
      testid="refund-page"
      eyebrow="legal · refund & cancellation"
      title="Refund & Cancellation Policy"
      lastUpdated="2026-05-18"
    >
      <Section heading="Policy overview">
        <p
          data-testid="refund-strict-banner"
          className="rounded-xl border border-amber-500/40 bg-amber-500/[0.06] p-4 text-amber-100"
        >
          <strong className="text-amber-300">All sales are final.</strong> The
          Founder Mode Quest operates a strict <strong className="text-amber-300">no-refund</strong>{" "}
          policy. Once payment is completed and access to Quest 2 (or any paid
          quest) has been activated for your account, no refunds will be issued
          under any circumstances.
        </p>
      </Section>

      <Section heading="Why no refunds — and how we keep it fair">
        <p>
          We offer <strong className="text-zinc-200">Quest 0 (What&apos;s Your
          Founder Face?)</strong> and{" "}
          <strong className="text-zinc-200">Quest 1 (Escape Your 9-5)</strong>{" "}
          completely free, forever, with no credit card required. These two quests
          let you fully experience the AI mentor&apos;s Socratic style, scoring
          across five founder dimensions, the quest interface, and the depth of
          challenge before any payment decision.
        </p>
        <p>
          If the platform is not what you expected after completing Quest 0 and
          Quest 1, simply do not purchase. Once you do purchase, you are agreeing
          to lifetime access in exchange for a non-refundable one-time fee.
        </p>
      </Section>

      <Section heading="Technical issues — we will fix access, not refund">
        <p>
          If you experience a technical issue that prevents you from accessing paid
          content after a successful payment, email us at{" "}
          <a
            href="mailto:praveen@thefoundermode.in"
            className="text-amber-300 hover:text-amber-200"
          >
            praveen@thefoundermode.in
          </a>{" "}
          within <strong className="text-zinc-200">7 days</strong> of the payment.
          We will:
        </p>
        <ul className="list-disc pl-6 space-y-1 marker:text-amber-400">
          <li>Verify your payment with Razorpay or Stripe</li>
          <li>Restore your access immediately</li>
          <li>Investigate and fix any platform-side issue</li>
        </ul>
        <p>
          However, this remedy is <strong className="text-zinc-200">restored
          access only</strong>. No monetary refund will be issued for technical
          issues that we resolve.
        </p>
      </Section>

      <Section heading="Cancellation">
        <p>
          The Founder Pass is a one-time lifetime purchase — there is no
          subscription, no recurring billing, and nothing to cancel. You will{" "}
          <strong className="text-zinc-200">never be charged a second time</strong>{" "}
          on the same account.
        </p>
      </Section>

      <Section heading="Chargebacks">
        <p>
          Initiating a chargeback or payment dispute through your card issuer or
          bank — instead of contacting us first — will result in:
        </p>
        <ul className="list-disc pl-6 space-y-1 marker:text-amber-400">
          <li>Immediate suspension of your account and revocation of access</li>
          <li>Submission of full payment, access, and conversation logs to the
          processor (Razorpay or Stripe) to dispute the chargeback</li>
          <li>Permanent ban from future purchases</li>
        </ul>
        <p>
          Please email us first. We respond within 1 business day and have resolved
          every legitimate issue without a chargeback.
        </p>
      </Section>

      <Section heading="Contact">
        <p>For any payment or access concerns:</p>
        <ul className="list-none pl-0 space-y-1 text-zinc-300">
          <li>Email: <a href="mailto:praveen@thefoundermode.in" className="text-amber-300 hover:text-amber-200">praveen@thefoundermode.in</a></li>
          <li>Phone: +91 94483 10439</li>
          <li>Support hours: Monday–Friday, 10 AM – 6 PM IST</li>
          <li>Address: Super Founder Hub, Kanapura Main Road, Bangalore, Karnataka, India</li>
        </ul>
      </Section>
    </LegalShell>
  );
}
